<script lang="ts">
    import cn from 'classnames';
    import { classList } from 'svelte-body';
    import { getErrorComponent } from '$lib/components/error';

    import { MainWrapper } from '@components/layout/main-wrapper';
    import { bodyClass, globalStore } from '@components/stores';
    import { LL, setLocale } from '@i18n/i18n-svelte';
    import { loadLocaleAsync } from '@i18n/i18n-util.async';
    import * as Sentry from '@sentry/sveltekit';

    import '$lib/styles/design-tokens.css';
    import s from './(main)/[[lang=lang]]/layout.module.css';

    import { page } from '$app/stores';
    import type { ComponentType } from 'svelte';

    loadLocaleAsync('en').then(() => {
        setLocale('en');
    });

    const component: ComponentType = getErrorComponent($page.error?.code);
    const code: string = $page.error?.code?.toString() ?? '';
    const message: string = $page.error?.message ?? '';

    if (message && !message.includes('Not found')) {
        Sentry.captureException(new Error(message || 'Unknown error'), {
            contexts: {
                errorInfo: {
                    code,
                    message,
                    expected: false,
                },
            },
        });
    }
</script>

<svelte:head>
    <title>{$LL.error.metaTitle({ code })}</title>
    <meta name="description" content={$LL.error.metaDescription({ message })} />
</svelte:head>

<svelte:body use:classList={cn({ [s.desktop]: $globalStore.isDesktopSite }, $bodyClass)} />

<MainWrapper>
    <svelte:component this={component} code={code}></svelte:component>
</MainWrapper>
